@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/transcript-subtitles-panel/subtitle-style-panel/clipping-studio-subtitle-style-panel.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.subtitle-style-panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  border: none;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  z-index: 20;
  font-family: "Open Sans", sans-serif;
}
.subtitle-style-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
}
.subtitle-style-panel__title {
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
}
.subtitle-style-panel__close {
  background: none;
  border: none;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}
.subtitle-style-panel__close:hover {
  color: rgba(0, 0, 0, 0.85);
}
.subtitle-style-panel__body {
  flex: 1;
  overflow-y: auto;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.subtitle-style-panel__section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.subtitle-style-panel__label {
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.35);
  text-transform: uppercase;
}
.subtitle-style-panel__label--with-icon {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.subtitle-style-panel__font-error {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  display: block;
  cursor: default;
}
.subtitle-style-panel__dropdown {
  width: 100% !important;
  min-width: 0;
  max-width: 100%;
}
.subtitle-style-panel__position {
  display: flex;
  gap: 6px;
}
.subtitle-style-panel__pos-btn {
  flex: 1;
  padding: 6px 8px;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
}
.subtitle-style-panel__pos-btn--active {
  border-color: rgb(45, 187, 252);
  color: rgb(45, 187, 252);
  background: rgba(45, 187, 252, 0.08);
}
.subtitle-style-panel__preview {
  position: relative;
  width: 100%;
  height: 96px;
  flex-shrink: 0;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  overflow: hidden;
  cursor: text;
  background-color: #e6e6e6;
  background-image:
    linear-gradient(
      45deg,
      #d0d0d0 25%,
      transparent 25%,
      transparent 75%,
      #d0d0d0 75%),
    linear-gradient(
      45deg,
      #d0d0d0 25%,
      transparent 25%,
      transparent 75%,
      #d0d0d0 75%);
  background-size: 16px 16px;
  background-position: 0 0, 8px 8px;
}
.subtitle-style-panel__preview-scroll {
  height: 100%;
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}
.subtitle-style-panel__preview-scroll::-webkit-scrollbar {
  display: none;
}
.subtitle-style-panel__preview-text {
  margin-inline: auto;
  flex: 0 0 auto;
  min-width: 1px;
  width: max-content;
  white-space: pre;
  outline: none;
}
.subtitle-style-panel__footer {
  padding: 12px 14px;
  border-top: 1px solid rgba(0, 0, 0, 0.14);
}
.subtitle-style-panel__apply {
  width: 100%;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 700;
  border: none;
  border-radius: 6px;
  background: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
  cursor: pointer;
}
.subtitle-style-panel__apply:hover {
  opacity: 0.9;
}
/*# sourceMappingURL=clipping-studio-subtitle-style-panel.component.css.map */
